export default {
  user: {},
  userData: {},
  otp: {},
  forgotPasword: {},
  loginAction: "",
  ticker: {},
};
